import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { ApiGenericResponse } from "../ApiGenericResponse";

const ENDPOINT = "/device/reset";

export class SendMachineResetCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";
    params: SendMachineResetReqData;

    constructor(params: SendMachineResetReqData) {
        super();
        this.params = params;
    }

    public async execute(): Promise<ApiGenericResponse> {
        var res = await this.executeCommand(null, null, this.params);
        return new ApiGenericResponse(res);
    }
}

export class SendMachineResetReqData {
    installationName: string;
    serialNumber: string;

    constructor(installationName: string, serialNumber: string) {
        this.installationName = installationName;
        this.serialNumber = serialNumber;
    }
}
